/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_SettingsInputs */

const en_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot change settings`)
};

const fr_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de changement de plan`)
};

const de_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen ändern`)
};

const it_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di modifica dello scatto`)
};

const ru_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение настроек съемки`)
};

const es_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes de cambio de toma`)
};

const zh_cn2_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄设置`)
};

const ja_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更設定`)
};

const hi_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट बदलने की सेटिंग्स`)
};

const pt_pt2_shot_change_settings = /** @type {(inputs: Shot_Change_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar configurações de disparo`)
};

/**
* | output |
* | --- |
* | "Shot change settings" |
*
* @param {Shot_Change_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_settings = /** @type {((inputs?: Shot_Change_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shot_change_settings(inputs)
	if (locale === "de") return de_shot_change_settings(inputs)
	if (locale === "it") return it_shot_change_settings(inputs)
	if (locale === "ru") return ru_shot_change_settings(inputs)
	if (locale === "es") return es_shot_change_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_shot_change_settings(inputs)
	if (locale === "ja") return ja_shot_change_settings(inputs)
	if (locale === "hi") return hi_shot_change_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_shot_change_settings(inputs)
	return en_shot_change_settings(inputs)
});